import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import router from "./router";
import config from "./config";
import service from "./api-service";
import VueUtils from "@/libs/vue-utils";
import Vant from "vant";
import { Icon } from 'vant';
import { CountDown } from 'vant-green';


import "vant/lib/index.css";
import { getPlatform } from "@/libs/common-utils/common-utils";
import VConsole from "vconsole";
import './permission'

Vue.prototype.$config = config;
Vue.prototype.$service = service;

Vue.config.productionTip = false;
Vue.use(Vant)
  .use(VueUtils).use(CountDown);
if (store.getters.env_mode && store.getters.env_mode == "test") {
  Vue.use(new VConsole());
}

// 微信浏览器缓存清理
function clearWechatCache() {
  // 检查是否在微信浏览器中
  const isWechat = /MicroMessenger/i.test(navigator.userAgent);
  if (isWechat) {
    // 检查是否是第一次访问（没有时间戳参数）
    const url = new URL(window.location.href);
    if (!url.searchParams.has('_t')) {
      // 第一次访问，添加时间戳参数强制刷新
      const currentTime = new Date().getTime();
      url.searchParams.set('_t', currentTime);
      window.location.replace(url.toString());
      return;
    }
    
    // 检查时间戳是否过期（超过1小时）
    const timestamp = parseInt(url.searchParams.get('_t'));
    const currentTime = new Date().getTime();
    const oneHour = 60 * 60 * 1000; // 1小时的毫秒数
    
    if (currentTime - timestamp > oneHour) {
      // 时间戳过期，更新为新的时间戳
      url.searchParams.set('_t', currentTime);
      window.location.replace(url.toString());
    }
  }
}

// 页面加载时执行缓存清理
clearWechatCache();

initializtionProgram();

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

/**
 * 初始化工作 配置渠道入口
 */
function initializtionProgram() {
  let platform = getPlatform();
  store.commit("setPlatformType", platform);
  let env_mode =
    decodeURIComponent(
      (new RegExp("[?|&]" + "env_mode" + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null;
  if (env_mode) store.commit("setEnvMode", env_mode);
}
